/** Proveedores globales: query client, toasts y sesión. En este orden. */
import { useState, type ReactNode } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "../lib/auth/index.js";
import { ToastProvider } from "../components/ui/Toast.js";
import { createQueryClient } from "../lib/queries/client.js";

export function Providers({ children }: { children: ReactNode }) {
  const [client] = useState(createQueryClient);
  return (
    <QueryClientProvider client={client}>
      <ToastProvider>
        <AuthProvider>{children}</AuthProvider>
      </ToastProvider>
    </QueryClientProvider>
  );
}
